import Modal from './Modal'
import withModalManager from './ModalManager'

export default Modal
export { withModalManager }
